<!-- TEXT, STRINGS -->
<ng-container *ngIf="column.dataType === 'text' || column.dataType === 'string' || column.dataType === 'month'">
  <miq-text
    *ngIf="column.inputType === 'Text'"
    class="filter--text"
    [panelClass]="column.panelClass"
    [(currentValue)]="value"
    [required]="column.required"
    [column]="column"
    (currentValueChange)="emitChange($event)"
  ></miq-text>

  <miq-select
    *ngIf="
      (column.inputType === 'Dropdown' || column.dataType === 'month' || column.lookupCategory) &&
      column.field !== 'confidentiality_f'
    "
    class="filter--select"
    [panelClass]="'editbox-dropdown ' + column.panelClass"
    [(currentValue)]="value"
    [values]="values"
    [placeholder]="state"
    [required]="column.required"
    [column]="column"
    (currentValueChange)="emitChange($event)"
  >
  </miq-select>

  <miq-select-confidentiality
    *ngIf="column.lookupCategory && column.field === 'confidentiality_f'"
    class="filter--select"
    [(currentValue)]="value"
    [values]="values"
    [placeholder]="state"
    [required]="column.required"
    [column]="column"
    (currentValueChange)="emitChange($event)"
    [userConfidentialityLevel]="record.miqProperties?.userConfidentiality"
    [recordConfidentialityLevel]="record.confidentiality_f"
  ></miq-select-confidentiality>
</ng-container>

<!-- NUMERICS ("integer", "numeric") -->
<ng-container *ngIf="column.dataType === 'numeric' || column.dataType === 'integer' || column.dataType === 'id'">
  <ng-container [ngSwitch]="column.inputType">
    <miq-select
      *ngSwitchCase="'Dropdown'"
      class="filter--select"
      [(currentValue)]="value"
      [values]="values"
      [placeholder]="state"
      [required]="column.required"
      [column]="column"
      (currentValueChange)="emitChange($event)"
    >
    </miq-select>

    <miq-number
      *ngSwitchDefault
      class="filter--number"
      [panelClass]="column.panelClass"
      [(currentValue)]="value"
      [required]="column.required"
      [column]="column"
      [format]="column.dataType === 'numeric'"
      [dataType]="column.dataType"
      [precision]="column?.options?.format"
      (currentValueChange)="emitChange($event)"
    >
    </miq-number>
  </ng-container>
</ng-container>

<!-- BOOLEANS "boolean" -->
<!--  TODO: (DeAris) hardcode fix for closing patch urgently for now-->
<ng-container
  *ngIf="
    column.columnId === OPEX_MONTHLY_YEARLY_COLUMN_ID && (column.dataType === 'boolean' || column.dataType === 'bool')
  "
>
  <mat-radio-group [(ngModel)]="column.value" (change)="emitCustomChanges(column.columnId, $event)">
    <mat-radio-button *ngFor="let val of column.values; let i = index" [value]="val.key">{{
      'recordsSearch.' + (val.value | lowercase) | xTranslate: { number: i + 1 }
    }}</mat-radio-button>
  </mat-radio-group>
</ng-container>

<ng-container
  *ngIf="
    column.columnId !== OPEX_MONTHLY_YEARLY_COLUMN_ID && (column.dataType === 'boolean' || column.dataType === 'bool')
  "
>
  <ng-container [ngSwitch]="column.inputType">
    <miq-select
      *ngSwitchCase="'Dropdown'"
      class="filter--select"
      [(currentValue)]="value"
      [values]="values"
      [placeholder]="state"
      [required]="column.required"
      [column]="column"
      (currentValueChange)="emitChange($event)"
    ></miq-select>
  </ng-container>
</ng-container>

<!-- DATES
  "timestamp with time zone"
  "date"
-->
<ng-container *ngIf="column.dataType === 'timestamp with time zone' || column.dataType === 'date'">
  <miq-number
    *ngIf="column.inputType === 'Number'; else dateInput"
    class="filter--number"
    [(currentValue)]="value"
    [required]="column.required"
    [format]="false"
    (currentValueChange)="emitChange($event)"
  >
  </miq-number>
  <ng-template #dateInput>
    <miq-date
      class="filter--date"
      [(currentValue)]="value"
      [required]="column.required"
      [panelClass]="column.panelClass"
      (currentValueChange)="emitChange($event)"
    >
    </miq-date>
  </ng-template>
</ng-container>

<!-- TEXT ("textarea") -->
<ng-container *ngIf="column.dataType === 'textarea'">
  <miq-textarea
    class="filter--textarea"
    [(currentValue)]="value"
    (currentValueChange)="emitChange($event)"
    [column]="column"
    [required]="column.required || column.UOMValidation"
  ></miq-textarea>
</ng-container>
